import { useIntl } from "react-intl";

import { useLocalizedHref } from "@/libraries/web-framework";

const LegalServiceManagementTemplate = () => {
    const intl = useIntl();

    const LearnMoreLink = `https://www.atlassian.com${useLocalizedHref(
        "/software/jira/templates/legal-service-management"
    )}`;

    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.LegalServiceManagementTemplate.header",
            defaultMessage: "Legal service management template"
        }),
        body: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.LegalServiceManagementTemplate.body",
            defaultMessage:
                "Designed for legal teams looking for a clear and central way to track and manage their work. This template creates, tracks, and manages your contracts through the review cycle to resolution."
        }),
        link: intl.formatMessage(
            {
                id: "JiraServiceManagementPricingPage.features.LegalServiceManagementTemplate.link",
                defaultMessage:
                    "<learnMore>Learn more</learnMore> about the legal service management template."
            },
            {
                learnMore: (chunk: React.ReactNode) => (
                    <a
                        href={LearnMoreLink}
                        data-event="clicked"
                        data-event-component="linkButton"
                        data-product-key="jiraServiceManagement"
                        data-label-english="Learn more"
                    >
                        {chunk}
                    </a>
                )
            }
        )
    };

    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
            <p>{messages.link}</p>
        </>
    );
};

export default LegalServiceManagementTemplate;
